import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from '@mui/material'
import CircularProgressWithLabel from './CircularProgressWithLabel'

const StatsExportDialog = ({ open, progress, onClose }) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Exporting</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {progress === 100 ? 'Finished' : 'Exporting'}
        </DialogContentText>
        {progress < 100 && <CircularProgressWithLabel variant="indeterminate" value={progress} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus disabled={!(progress === 100)}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default StatsExportDialog
